<template>
  <div id="main" class="container">
    <alert-area class="my-3" :alerts="alerts"></alert-area>
    <div class="my-3">
      <button class="btn btn-primary" @click="stamp()">
        <font-awesome-icon icon="stopwatch" /> STAMP
      </button>
      <span id="stamped" class="ml-1 text-success" style="display: none;">Stamped!</span>
    </div>
    <div class="my-3">
      <button class="btn btn-sm" :class="filterBtnClass"
        data-toggle="collapse" data-target="#filter">
        <font-awesome-icon icon="filter" /> Filter
      </button>
    </div>
    <div id="filter" class="my-3 collapse">
      <div class="row">
        <div class="form-group col">
          <label for="date-from"> From: </label>
          <input type="date" class="form-control" id="date-from" v-model="stampFilters.dateFrom">
        </div>
        <div class="form-group col">
          <label for="date-to"> To: </label>
          <input type="date" class="form-control" id="date-to" v-model="stampFilters.dateTo">
        </div>
      </div>
      <div>
        <button class="btn btn-sm btn-outline-primary" @click="resetFilter">
          <font-awesome-icon icon="eraser" /> Reset filter
        </button>
      </div>
    </div>

    <hr>

    <div id="timerecords" class="my-3">
      <h3 class="mb-3">Records</h3>
      <ul class="list-group">
        <li class="list-group-item d-flex p-0"
          v-for="s in stampsSliced"
          :key="s">
          <div class="py-3 px-4 mr-auto">{{ s | timestamp }}</div>
        </li>
        <li id="read-more" class="list-group-item text-primary"
          style="cursor: pointer;"
          v-if="stampsView.length > viewLimit"
          @click="readMore()">
            <infinite-loading v-if="preferences.autoReadMore" @infinite="infiniteHandler"></infinite-loading>
            More records...
          </li>
      </ul>
      <div class="alert alert-secondary text-muted" v-if="stampsView.length == 0">
        No Records
      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery'
import AlertArea from '../components/AlertArea.vue'
import alerts from '../resources/alerts.js'
import common from '../resources/common.js'
import { recordComponentBase as recordMixin } from '../resources/mixins.js'

export default {
  name: 'Main',
  mixins: [
    recordMixin
  ],
  components: {
    AlertArea
  },
  created: function() {
    if (!common.storageAvailable('localStorage')) {
      this.alerts.push(alerts.d01);
      return;
    }
    let storage = window.localStorage;
    let storageStamp = storage.getItem('stamps');
    if(storageStamp) {
      this.stamps = JSON.parse(storageStamp);
    } else {
      this.alerts.push(alerts.p01);
    }

    let preferences = storage.getItem('preferences');
    if(preferences) {
      preferences = JSON.parse(preferences);
      this.preferences['onLoadStamp'] = !!preferences['onLoadStamp'];
      this.preferences['autoReadMore'] = !!preferences['autoReadMore'];
    }

    if(this.preferences.onLoadStamp === true) {
      this.stamp(true);
    }
  },
  watch: {
    stamps: 'saveStamps',
    stampFilters: 'resetLimit',
  },
  methods: {
    stamp: function(quiet) {
      this.stamps.unshift(Date.now());
      this.viewLimit++;
      if(!quiet) {
        $('#stamped').show().fadeOut(1000);        
      }
    },
    saveStamps: function(newStamps) {
      window.localStorage.setItem('stamps', JSON.stringify(newStamps));
    },
  },
}
</script>

<style>
</style>
